module.exports = __webpack_public_path__ + "static/footer-36775646c30d9f44a13cc569d9ed873d.jpg";